//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

import * as moment from "moment";
import 'moment/locale/fr-ca';
import 'moment/locale/fr';

export function pointsFormat(points, language) {
  let output;
  let nfObject = new Intl.NumberFormat("en-US");
  switch (language) {
    case "en":
      output = nfObject.format(points);
      break;
    case "fr":
      output = points?.toLocaleString("fr");
      break;
    default:
      output = nfObject.format(points);
  }
  return output;
}

export function dateFormat(date, language) {
  let output;
  switch (language) {
    case "en":
      moment.locale('en-US')
      output = moment(date).format("MMM-DD-YYYY");
      break;
    case "fr":
      moment.locale('fr')
      output = moment(date).format("DD-MMM-YYYY").replace('.', '');
      break;
    default:
  }
  return output;
}

export function currencyFormat(points, language, org) {
  let output;
  if (org == "Henry Schein Canada") {
    if (language == "fr") {
      output = `${points?.toLocaleString("fr", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })} $`
    } 
    else {
      if (points >= 0) {
        output = `$${points?.toLocaleString("en", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`
      } 
      else {
        output = `-$${(-1 * points)?.toLocaleString("en", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`;
      }
    }
  } 
  else {
    // output = (points >= 0) ? `$${pointsFormat(points, language)}` : `-$${pointsFormat(Math.abs(points), language)}`;
    if (points >= 0) {
      output = `$${(points)?.toLocaleString("en", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`
    } 
    else {
      output = `-$${(Math.abs(points))?.toLocaleString("en", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`;
    }
  }
  return output;
}

export function tierRatioFormat(value, language) {
  let output;
  switch (language) {
    case "en":
      output = value ? `${value}x` : "-";
      break;

    case "fr":
      if (value) {
        output = `${parseFloat(value)?.toLocaleString("fr")}x`;
      } else {
        output = "-";
      }
      break;

    default:
  }
  return output;
}

export function dateAndTimeFormat(date, language) {
  let output;
  switch (language) {
    case "en":
      moment.locale('en-US')
      output = moment(date).format("MMM-DD-YYYY hh:mm A");
      break;
    case "fr":
      moment.locale('fr')
      output = moment(date).format("DD-MMM-YYYY hh:mm A").replace('.', '');
      break;
    default:
  }
  return output;
}
